import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

Builder.registerComponent(
  dynamic(() => import('./components/Counter/Counter')),
  {
    name: 'Counter',
    inputs: [
      {
        name: 'initialCount',
        type: 'number',
      },
    ],
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Home/HomepageV2/BrandLogos')),
  {
    name: 'BrandLogos',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Home/HomepageV2/TextWithHighlight')),
  {
    name: 'TextWithHighlight',
  },
);
